import { useContext } from 'react';
import { FlagContext } from '../contexts/flag';
var useFeatures = function useFeatures() {
  var _useContext = useContext(FlagContext),
    features = _useContext.features;
  return features;
};
export default useFeatures;